export default "__VITE_ASSET__929f5bd8__"